import { MaxButton, StatusMaxButton } from "components/view/button";
import { AppReducerStateProps, store } from "lib/store";
import { memberActionTypes } from "lib/store/member/reducer";
import { Modal } from "react-bootstrap";
import { connect } from "react-redux";
import Img from "react-cloudimage-responsive";

interface showRpsHowtoModalProps {
  state: AppReducerStateProps;
  closeModal: Function;
}

export const showRpsHowtoModal = () => {
  store.dispatch({
    type: memberActionTypes.ACTION_OPEN_MODAL_RPS_HOW_TO,
  });
};

function RpsHowtoModal(props: showRpsHowtoModalProps) {
  const { closeModal } = props;
  const { isModalHowToRps } = props.state.member;

  return (
    <Modal
      {...props}
      size="lg"
      scrollable={true}
      contentClassName="view-background-transparent"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={isModalHowToRps}
      animation={false}
      onHide={() => {
        closeModal();
      }}
      dialogClassName="modal-dialog"
    >
      <Modal.Header closeButton className="modal-header">
        <Modal.Title id="example-modal-sizes-title-lg">
          <div className="center-row-content text-bold">
            <span>เกม เป่า ยิ้ง ฉุบ!!</span>
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <div>
            <p>
              กติกาการเล่นเป่ายิ้งฉุบ คือแต่ละคนจะออก ค้อน, กรรไกร, กระดาษ ซึ่ง
              ท่านมีโอกาสชนะ 1 ใน 3 จะไม่มี บอท มาเล่นในห้องของท่านแน่นอน 100%{" "}
            </p>
            <h3 className="text-title margin-top-20">วิธีการเล่น</h3>
            <p>เกม เป่า ยิ้ง ฉุบ สามารถเล่นได้ง่ายๆ</p>
            <p>
              <span>วิธีเล่น (สร้างห้องเดิมพัน)</span>
            </p>
            <ul>
              <li>
                เลือกแล้ว จากนั้น เลือกรูป ค้อน, กรรไกร, กระดาษ
                ได้อย่างใดอย่างหนึ่ง
              </li>
              <li>เลือกราคาห้องที่ท่านต้องการท้าประลอง</li>
              <li>จากนั้นกดปุ้ม สร้างห้องเดิมพัน</li>
              <li>ทุกครั้งที่ท่านชนะจะหัก 0.05 % จาก uDiamond ที่ท่านได้รับ</li>
            </ul>
            <div className="col-md-6 center-row-content">
              <Img
                ratio={1.06 / 1}
                className="full-width-image"
                src="snam-rps-howto-1.png"
              ></Img>
            </div>
            <p className="margin-top-10">
              <span>วิธีเล่น (หาห้องผู้เล่นท่านอื่นเพื่อท้าประลอง)</span>
            </p>
            <ul>
              <li>เลือกราคาห้องที่ท่านต้องการท้าประลอง</li>
              <li>
                จากนั้น เลือกรูป ค้อน, กรรไกร, กระดาษ ได้อย่างใดอย่างหนึ่ง
              </li>
              <li>ทุกครั้งที่ท่านชนะจะหัก 0.05 % จาก uDiamond ที่ท่านได้รับ</li>
            </ul>
            <div className="col-md-6 margin-top-10 center-row-content">
              <Img
                ratio={1.2 / 1}
                className="full-width-image"
                src="snam-rps-howto-2.png"
              ></Img>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="modal-footer">
        <MaxButton
          className="margin-top-10"
          title="ปิด"
          status={StatusMaxButton.submit}
          onClick={() => {
            closeModal();
          }}
        ></MaxButton>
      </Modal.Footer>
    </Modal>
  );
}

const mapStateToProps = (state: AppReducerStateProps) => {
  return {
    state: state,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    closeModal: () => {
      dispatch({
        type: memberActionTypes.ACTION_CLOSE_MODAL_RPS_HOW_TO,
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RpsHowtoModal);
